export function extracts_transm(ref) {
    const s_transm = ref.substr(3, 4) + ref.substr(8, 4);
    return s_transm;
}

export function extractt_servicio(ref) {
    const subRef = ref.substr(0, 3);
    switch (subRef) {
        case '001':
            return '3';
        case '002':
            return '482';
        case '003':
            return '004';
        case '004':
            return '14';
        case '005':
            return '1';
        case '006':
            return '377';
        case '085':
            return '256';
        case '010':
            return '015';
        case '011':
            return '016';
        case '012':
            return '618';
        case '013':
            return '516';
        case '014':
            return '031';
        case '016':
            return '484';
        case '086':
            return '1';
        case '037':
            return '37';
        case '038':
            return '38';
        case '045': // esto para el caso de que sea un servicio de la 45 de fotomultas, debe ser en otra rama 
            return '17';
        default:
    }

}
